export default __webpack_public_path__ + "static/media/ArpitaKar.60247762.jpg";